import { Separator } from './Separator';
import { ContentWrapperCell } from './ContentWrapperCell';
import { ZielstundenField } from '../../../components';
import { useTagebuchEinstellungen } from '@/domain/controlling/hooks/useTagebuchEinstellungen';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function ZielstundenCell({
  umsatzZielstunden,
  absatzZielstunden,
}: {
  umsatzZielstunden: number | undefined;
  absatzZielstunden: number | undefined;
}) {
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { umsatzplanungAnzeige: tagebuchAnzeige } =
    useTagebuchEinstellungen(standortId);

  return (
    <ContentWrapperCell>
      {tagebuchAnzeige !== 'ABSATZ_PRODUKTIVITAET' && (
        <ZielstundenField value={umsatzZielstunden} />
      )}
      {tagebuchAnzeige === 'UMSATZ_ABSATZ_PRODUKTIVITAET' && <Separator />}
      {tagebuchAnzeige !== 'UMSATZ_PRODUKTIVITAET' && (
        <ZielstundenField value={absatzZielstunden} />
      )}
    </ContentWrapperCell>
  );
}
